import { AddPassengerDetailsForm } from "@/features/booking-history/detail/AddPassengerDetailsForm";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function AddPassengerDetailsPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-7xl mx-auto px-4 pt-4 pb-16 sm:px-6 lg:px-8">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={() => navigate(-1)}
          aria-label="Go back"
          className="cursor-pointer flex items-center gap-2 text-lg font-semibold text-secondary-foreground"
        >
          <ChevronLeft size={24} className="text-primary" />
          Add Passenger Details
        </button>
      </div>
      <div className="mt-8">
        <AddPassengerDetailsForm />
      </div>
    </div>
  );
}
